export function inr(amount) {
  if (amount === null || amount === undefined || amount === "") return "";
  const n = Math.round(Number(amount));
  if (Number.isNaN(n)) return "";
  return "₹" + n.toLocaleString("en-IN");
}

export function chipGlow(chip) {
  if (!chip) return "#a1a1a6";
  const c = chip.trim().toLowerCase();
  if (c.includes("intel") || c.includes("core m")) return "#a1a1a6";
  if (c.startsWith("a")) return "#64d2ff";
  const proMax = c.includes("pro") || c.includes("max");
  if (c.startsWith("m1")) return proMax ? "#bf5af2" : "#ff375f";
  if (c.startsWith("m2")) return "#2997ff";
  if (c.startsWith("m3")) return "#ff9f0a";
  if (c.startsWith("m4")) return "#64d2ff";
  return "#a1a1a6";
}

export const STATUS_COLORS = {
  "In stock": { text: "#30d158", bg: "rgba(48,209,88,0.12)", border: "rgba(48,209,88,0.35)" },
  Reserved: { text: "#ff9f0a", bg: "rgba(255,159,10,0.12)", border: "rgba(255,159,10,0.35)" },
  Sold: { text: "#ff453a", bg: "rgba(255,69,58,0.12)", border: "rgba(255,69,58,0.35)" },
  Hidden: { text: "#98989d", bg: "rgba(152,152,157,0.12)", border: "rgba(152,152,157,0.35)" },
};

export const FAMILIES = ["MacBook Air", "MacBook Pro", "MacBook", "MacBook Neo"];
export const BATTERY_CONDITIONS = ["Normal", "Service Recommended", "Replace Now"];
export const ENQUIRY_TYPES = ["Buy", "Sell", "Trade-in", "Repair", "Warranty", "Business", "Other"];
export const ENQUIRY_STATUS = ["New", "Replied", "Visited store", "Won", "Lost"];
